import { OfferLinkedLocation, OfferLinkedLocationType, RegionsEnum } from '@luminovo/api-contracts';

import { formatRegionAsName, formatRegionEnumAsISO3166Alpha3 } from './formatSupplierAndStockLocation';

export function formatOfferLinkedLocation(loc: OfferLinkedLocation): string {
    if (loc.type !== OfferLinkedLocationType.SupplierAndStockLocation) {
        return loc.name;
    }

    const { supplier, stock_location } = loc;
    if (stock_location === RegionsEnum.Unknown) {
        return supplier.name;
    }

    const stockLocationText = formatRegionEnumAsISO3166Alpha3(stock_location) || formatRegionAsName(stock_location);
    return `${supplier.name} · ${stockLocationText}`;
}
